import * as actionTypes from "../constants/actionTypes";
import * as types from "../constants/componentTypes";
import * as modelHelper from "../helpers/modelHelper";
import * as config from "../constants/config";

const initialState = {
    activeFormulaIndex: null,
    formulas: [],
    productFilter: [],
    fandeckFilter: [],
    deltaFilter: config.DEFAULT_SPECTRO_DELTA_FILTER
};

/**
 * Structure of order store:
 * - activeFormulaIndex     {Number | null}
 * - formulas               {Array}
 * - productFilter          {Array}
 * - fandeckFilter          {Array}
 * - deltaFilter            {Number}
 */
export const spectroTabReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.CLOSE_ACTIVE_TAB:
        case actionTypes.CLOSE_ALL_TABS_EXCEPT_ACTIVE:
        case actionTypes.CLOSE_ALL_TABS:
            let tab;
            for (tab of action.payload.newTabList) {
                if (tab.type === types.SPECTRO_TAB) {
                    return state;
                }
            }

            return initialState;
        case actionTypes.SAVE_SPECTRO_FORMULAS:
            return {
                ...state,
                activeFormulaIndex: null,
                formulas: modelHelper.mapSpectroFormulasToObjects(action.payload.formulas)
            };
        case actionTypes.SPECTRO_SAVE_DELTA_FILTER:
            return {
                ...state,
                deltaFilter: action.payload.delta
            };
        case actionTypes.SPECTRO_SAVE_PRODUCT_FILTER:
            return {
                ...state,
                productFilter: action.payload.products
            };
        case actionTypes.SPECTRO_SAVE_FANDECK_FILTER:
            return {
                ...state,
                fandeckFilter: action.payload.fandecks
            };
        case actionTypes.SPECTRO_SAVE_ACTIVE_FORMULA:
            return {
                ...state,
                activeFormulaIndex: action.payload.index
            };
        case actionTypes.WEBSOCKET_CLOSED:
        case actionTypes.DATABASE_CHANGE:
        case actionTypes.DATABASE_CHANGE_GAMMA:
            return initialState;
        default:
            return state;
    }
};
